module.exports = __webpack_public_path__ + "img/eagle.0b068c34.png";